import { render, staticRenderFns } from "./ATable.vue?vue&type=template&id=24e3b651&scoped=true&"
import script from "./ATable.vue?vue&type=script&lang=js&"
export * from "./ATable.vue?vue&type=script&lang=js&"
import style0 from "./ATable.vue?vue&type=style&index=0&id=24e3b651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3b651",
  null
  
)

export default component.exports